import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/MDXPageLayout.js";
import PageBanner from '../../components/PageBanner';
import Button from '../../components/Button';
import HackavizFooter from '../../components/HackavizFooter';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<PageBanner styleId={1} title={"Hackaviz 2020"} description={"Les données"} mdxType="PageBanner" />
<section id="one">
<div className="inner">
<h1>{`Le tourisme dans la région Occitanie en 2018`}</h1>
<p>{`Tout au long de l’année chaque nuit, des milliers de touristes dorment dans notre belle région. Nous avons réussi à assembler un jeu de données unique qui les localise et les compte par nuitée. Nous connaissons les capacités d’hébergement (hôtel, camping,..) de chaque département. Nous savons aussi d’où ils viennent que ce soit d’un département Français ou de l’étranger. Nous savons enfin le temps qu’il faisait et les principaux événements culturels du jour.
A vous de jouer en utilisant tout ou partie des fichiers !`}</p>
<h2>{`Synthétique et facile d’accès`}</h2>
<ul>
<li parentName="ul">{`nuitees.xlsx et .csv       `}</li>
<li parentName="ul">{`(365 lignes / 15 colonnes)`}</li>
<li parentName="ul">{`par jour en synthèse par dpt`}</li>
</ul>
<h2>{`Le plus détaillé mais pas le plus simple à exploiter`}</h2>
<ul>
<li parentName="ul">{`par_origines.xlsx et .csv`}</li>
<li parentName="ul">{`(493 235 lignes / 8 colonnes)`}</li>
<li parentName="ul">{`par jour avec tous les détails`}</li>
</ul>
<h2>{`Croisement capacités x nuités, sert de complément optionnel aux autres`}</h2>
<ul>
<li parentName="ul">{`capacites.xlsx, .csv et .geojson`}</li>
<li parentName="ul">{`(13 lignes / 61 colonnes)`}</li>
<li parentName="ul">{`par semaine en catégories de nuitées par dpt`}</li>
</ul>
<p>{`Il est possible de faire de belles visualisations à partir d’un seul de ces trois fichiers de données, le plus simple étant nuitees qui est un aggrégat de par_origines. Les plus experts arriveront à combiner les trois, mais il n’est pas certain que la plus belle histoire ait besoin de toutes ces données.  L’important est de raconter une belle histoire avec des graphiques de qualité.`}</p>
<h1>{`Détails des fichiers et téléchargement`}</h1>
<h2>{`nuitées`}</h2>
<p>{`Regroupement des données à partir du fichier par_origines.
`}<em parentName="p">{`Pour chaque jour de l’année  (365 lignes / 15 colonnes)`}</em></p>
<ul>
<li parentName="ul">{`Date`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 09`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 11`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 12`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 30`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 31`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 32`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 34`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 46`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 48`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 65`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 66`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 81`}</li>
<li parentName="ul">{`Nombre de nuitées dans le département 82`}</li>
<li parentName="ul">{`Nombre de nuitées dans la région Occitanie`}</li>
</ul>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/nuitees.csv"} text={"nuitées.csv"} mdxType="Button" />
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/nuitees.xlsx"} text={"nuitées.xls"} mdxType="Button" />
<h2>{`par_origines`}</h2>
<p>{`Pour chaque jour de l’année 2018 (532 399 lignes / 8 colonnes) :`}</p>
<ul>
<li parentName="ul">{`Date`}</li>
<li parentName="ul">{`Département ou pays d’origine des touristes`}</li>
<li parentName="ul">{`Département de destination en Occitanie`}</li>
<li parentName="ul">{`Volume de nuitées dans le département de destination`}</li>
<li parentName="ul">{`Statut des vacances du département d’origine`}</li>
<li parentName="ul">{`Température à midi (solaire) du département de destination`}</li>
<li parentName="ul">{`Statut qualificatif de la météo du département de destination`}</li>
<li parentName="ul">{`Nombre d’événements majeurs dans le département de destination`}</li>
</ul>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/par_origines.csv"} text={"par_origine.csv"} mdxType="Button" />
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/par_origines.xlsx"} text={"par_origine.xls"} mdxType="Button" />
<h2>{`capacités`}</h2>
<p>{`Pour chaque département (13 lignes / 61 colonnes)`}</p>
<ul>
<li parentName="ul">{`Département`}</li>
<li parentName="ul">{`Nom du département`}</li>
<li parentName="ul">{`Population du département`}</li>
<li parentName="ul">{`Nombre de places (personnes) en hébergement collectif`}</li>
<li parentName="ul">{`Nombre de places (personnes) en hébergement locatif`}</li>
<li parentName="ul">{`Nombre de places (personnes) en hébergement de plein air`}</li>
<li parentName="ul">{`Nombre de places (personnes) en hébergement hôtellier`}</li>
<li parentName="ul">{`Nombre de places (personnes) total`}</li>
<li parentName="ul">{`Nombre de nuitées pour la semaine 1`}</li>
<li parentName="ul">{`Nombre de nuitées pour la semaine 53`}</li>
</ul>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/capacites.csv"} text={"capacites.csv"} mdxType="Button" />
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/capacites.xlsx"} text={"capacites.xls"} mdxType="Button" />
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/capacites.geojson"} text={"capacites.geojson"} mdxType="Button" />
<p>{`Donnés complémentaires :codage des départements, codage des pays et liste des événements.`}</p>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/complements.xlsx"} text={"complement.xls"} mdxType="Button" />
<h1>{`Les sources des jeux de données :`}</h1>
<ul>
<li parentName="ul">{`Les volumes de nuitées ont été construites par un opérateur de téléphonie mobile à partir des bornages téléphoniques. Ces données ont été fournies par le Comité Régional du Tourisme (CRT) `}</li>
<li parentName="ul">{`Les données concernant les capacités d’hébergement ont été construites par TDV à partir de données fournies par le Comité Régional du Tourisme (CRT).`}</li>
<li parentName="ul">{`Les données concernant les événements ont été construites par TDV à partir de données fournis par le Comité Régional du Tourisme (CRT)`}</li>
<li parentName="ul">{`Les données météo proviennent d’un site internet fournissant l’historique des données météo pour un grand nombre de villes en France et dans le monde`}</li>
<li parentName="ul">{`Les données de géométrie des départements sont incluses uniquement dans le fichier geojson. Ce format est adapté pour ceux qui souhaitent utiliser des outils de cartographie tels que le logiciel libre QGIS ou des librairies javascript telles que d3.js.`}</li>
</ul>
<p>{`Remarques : `}</p>
<ul>
<li parentName="ul">{`Les données de bornage téléphonique ne sont pas des données brutes mais le résultat d’un travail de traitement innovant (redressement, segmentation, anonymisation ) réalisé par l’opérateur de téléphonie avec la participation d’acteurs du tourisme. Les données “volume de nuitées” sont donc des estimations statistiques. `}</li>
<li parentName="ul">{`Les jeux de données sont à l’usage exclusif de l’Hackaviz 2020. Pour toutes autres utilisations, veuillez contacter l’association Toulouse dataviz. `}</li>
</ul>
<h1>{`Toutes les explications sur les données`}</h1>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020/blob/master/README.md"} text={"Descriptif des données"} mdxType="Button" />
<p>{`Les données et la documentation sont aussi sur notre site github.  `}</p>
<Button link={"https://github.com/ToulouseDataViz/Hackaviz2020"} text={"Github TDV"} mdxType="Button" />
<HackavizFooter year={'2020'} mdxType="HackavizFooter" />
</div>
</section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      